import React from 'react';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { observer } from 'mobx-react';
import { observable, makeObservable } from 'mobx';
import { CourseListPageState } from './states/CourseListPageState';
import { CourseList } from '../../components/molecules/courses/index/CourseList';
import { parseQueryParams, RouteLocation } from '../../types/location';
import './courseListPage.module.scss';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import { CourseListCard3, CourseListCardSpacer } from '../../components/molecules/courses/index/CourseListCard3';
import WritingExamMedal from './images/writing_exam_medal.png';
import PracticalExamMedal from './images/practical_exam_medal.png';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import {
  ExamSectionWritingType,
  ExamSectionPracticalType,
  ExamSectionStatIndexView,
  ExamSectionType,
} from '../../types/exam_section_stats';
import { CoursePackLink } from './CoursePackLink';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

type Props = {
  location: RouteLocation;
};

const COLUMNS_NUMBER = 3;
export const CourseListPage = withNavigation(NavigationSpecs.side())(
  authenticated(
    observer(
      class CourseListPage extends React.Component<Props> {
        pageState = new CourseListPageState();

        constructor(props: Props) {
          super(props);

          makeObservable(this, {
            pageState: observable,
          });
        }

        async componentDidMount() {
          const { preview } = parseQueryParams(this.props.location);
          this.pageState.init(preview === 'true');
        }
        render() {
          const { courses, completeLessons, examSectionStats } = this.pageState;
          function examSectionStatsFilter(stats: ExamSectionStatIndexView[], courseId: number, type: ExamSectionType) {
            return stats.filter((stat) => stat.course_id === courseId && stat.completed && stat.section_type === type);
          }
          const coursesArray = courses.getOrElse([]);
          const reminderColumns = courses.getOrElse([]).length % COLUMNS_NUMBER;
          const breadCrumbItems = [{ text: 'コース' }];
          return (
            <Page styleName="page">
              <BreadCrumb items={breadCrumbItems} hasHome />
              <PageHeader title="COURSES" testId="page-header-of-courses" />
              <PageBody styleName="page-body">
                <CoursePackLink state={this.pageState} />
                <div styleName="medal">
                  <img src={WritingExamMedal} styleName="medal-image" />
                  <span styleName="medal-description">筆記試験修了マーク</span>
                  <img src={PracticalExamMedal} styleName="medal-image" />
                  <span styleName="medal-description">実技試験修了マーク</span>
                </div>
                <CourseList>
                  {courses.loading && <LoaderRow />}
                  {coursesArray.map((course) => (
                    <CourseListCard3
                      key={course.id}
                      course={course}
                      styleName="course-list-card"
                      completeLesson={completeLessons
                        .getOrElse([])
                        .find((completeLesson) => completeLesson.course_id === course.id)}
                      writingSectionCompleteList={examSectionStatsFilter(
                        examSectionStats.getOrElse([]),
                        course.id,
                        ExamSectionWritingType
                      )}
                      practicalSectionCompleteList={examSectionStatsFilter(
                        examSectionStats.getOrElse([]),
                        course.id,
                        ExamSectionPracticalType
                      )}
                    />
                  ))}
                  {GlobalStatesV3.viewport.isDesktop &&
                    reminderColumns !== 0 &&
                    Array(COLUMNS_NUMBER - reminderColumns)
                      .fill(0)
                      .map((_, index) => <CourseListCardSpacer key={`course-list-card-spacer-${index}`} />)}
                </CourseList>
              </PageBody>
            </Page>
          );
        }
      }
    )
  )
);
